/**
 * Created by jesusrodriguez on 2/23/19.
 */
(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PhysicianReviewMedicationsController', PhysicianReviewMedicationsController);

    PhysicianReviewMedicationsController.$inject = ['$q', 'PatientMedication', 'CoreService', 'PopupService', 'toastr',
        '$rootScope', 'Chart', 'MedicationSearch', 'TypeLevelCare',
        'physicianCredentials', 'GenericEntityDatatableService'];

    function PhysicianReviewMedicationsController($q, PatientMedication, CoreService, PopupService, toastr,
                                                  $rootScope, Chart, MedicationSearch, TypeLevelCare,
                                                  physicianCredentials, GenericEntityDatatableService) {
        var vm = this;

        vm.facility = CoreService.getCurrentFacility();

        var params = {
            facilityId: CoreService.getCurrentFacility().id,
        }

        vm.descriptor = {
            title: 'Medications',
            entityClassHumanized: 'Medications',
            entityStateName: 'medications',
            service: PatientMedication,
            serviceMethod: 'findAllPhysicianReview',
            params: params,
            pagination: 'remote',
            newAction: false,
            withSelectionColumn: true,
            isVisibleSelectionColumn: function () {
                return CoreService.currentEmployeeHaveAnyCredential(physicianCredentials);
            },
            options: [
                {key: 'aaSorting', value: [[5, 'desc'], [2, 'asc']]}
            ],
            selectionColumn: 'id',
            columns: [
                {
                    name: 'id',
                    title: 'ID'
                },
                {
                    name: 'patientName',
                    title: 'Name',
                    options: [{key: 'width', value: '170px'}],
                    render: function (data) {
                        return data.lastName + ', ' + data.firstName;
                    }
                },
                {
                    name: 'mrNo',
                    title: 'MrNo'
                },
                {
                    name: 'dob',
                    title: 'DOB',
                    render: function (data) {
                        return moment(data.dob).format("MM/DD/YYYY");
                    }
                },
                {
                    name: 'medicationName',
                    title: 'Medication'
                },
                {
                    name: 'medicationStatus',
                    title: 'Status'
                },
                {
                    name: 'startDate',
                    title: 'Start Date',
                    render: function (data) {
                        return moment(data.startDate).format("MM/DD/YYYY");
                    }
                },
                {
                    name: 'endDate',
                    title: 'End Date',
                    render: function (data) {
                        return moment(data.endDate).format("MM/DD/YYYY");
                    }
                },
                {
                    name: null,
                    title: 'Entered By',
                    render: function (data) {
                        return data.lastNameEmployee + " " + data.firstNameEmployee;
                    }
                },
                {
                    name: null,
                    title: 'Signed By',
                    render: function (data) {
                        return data.physicianFirstName + " " + data.physicianLastName;
                    }
                },
                {
                    name: 'type',
                    title: 'Type'
                },
                {
                    name: null,
                    title: 'Discontinue By',
                    render: function (data) {
                        return data.firstNameDiscontinueBy ? (data.firstNameDiscontinueBy + " " + data.lastNameDiscontinueBy) : "";
                    }
                },
                {
                    name: null,
                    title: 'Discontinue Date',
                    render: function (data) {
                        return data.discontinueDate ? moment(data.discontinueDate).format("MM/DD/YYYY") : "";
                    }
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getDetailsAction(), {
                    action: function (data) {
                        return vm.viewDetails(data.id);
                    },
                }),
            ],
            leftActions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getSignAction(), {
                            name: 'Sign Selected',
                            disabledOnEmpty: true,
                            action: function (filter, selected) {
                                if (selected.length > 0) {
                                    return vm.signPatientMedications(selected);
                                }
                            },
                            ngIf: function () {
                                return CoreService.currentEmployeeHaveAnyCredential(physicianCredentials);
                            },
                        }),
                    ]
                },
            ],
            filters: [
                {
                    name: 'medication',
                    read: function (filter) {
                        return filter.medication ? filter.medication.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.name : "";
                    },
                    refresh: function (search, values) {
                        MedicationSearch.query({query: search}, function (result) {
                            values.length = 0;
                            values.push(...result);
                        });
                    },
                    placeholder: 'Select medication ...',
                    type: 'select',
                    visible: true,
                    ngClass: 'col-xs-12 col-sm-12 col-md-12 col-lg-12'
                },
                {
                    name: 'chartId',
                    read: function (filter) {
                        return filter.chartId ? filter.chartId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.firstName + ' ' + entity.lastName : "";
                    },
                    getSmallDisplayValue: function (entity) {
                        return '<strong>DOB: </strong>' + moment(entity.dateBirth).format("MM/DD/YYYY") + ' <strong>MrNo:</strong> ' + entity.mrNo;
                    },
                    refresh: function (search, values) {
                        Chart.fullFilter(
                            {
                                page: 0,
                                size: 20,
                                facilityId: CoreService.getCurrentFacility().id,
                                searchQuery: search,
                                statuses: ['CURRENT', 'ARCHIVE']
                            }, function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Select patient ...',
                    type: 'select',
                    visible: true
                },
                {
                    name: 'status',
                    placeholder: 'Medication Status...',
                    type: 'select',
                    values: ['CANCELED', 'FINISHED', 'SCHEDULED', 'DISCONTINUED'],
                    getValue: function (entity) {
                        return entity;
                    },
                    getDisplayValue: function (entity) {
                        return entity;
                    },
                    visible: true
                },
                {
                    name: 'mrNo',
                    // title: 'Barcode',
                    placeholder: 'MrNo...',
                    type: 'string',
                    visible: true
                },
                {
                    name: 'dob',
                    // title: 'Day of Birth',
                    placeholder: 'Day of Birth...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.dob ? moment(filter.dob).format("YYYY-MM-DD") : null;
                    },
                    visible: true
                },
                {
                    name: 'typeLevelCare',
                    read: function (filter) {
                        return filter.typeLevelCare ? filter.typeLevelCare.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.name : "";
                    },
                    refresh: function (search, values) {
                        TypeLevelCare.findAllByFacility(
                            CoreService.getFilterByFacility(CoreService.getCurrentFacility()), function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Level of Care ...',
                    type: 'select',
                    visible: true
                },
                {
                    name: 'medicationFrequency',
                    read: function (filter) {
                        return filter.medicationFrequency ? filter.medicationFrequency.id : null;
                    },
                    values: PatientMedication.getAllMedicationFrequency(),
                    getDisplayValue: function (entity) {
                        return entity ? entity.description : "";
                    },
                    placeholder: 'Select Frequency...',
                    type: 'select',
                    visible: true
                },
            ]
        }

        vm.viewDetails = viewDetails;
        vm.signPatientMedications = signPatientMedications;

        function viewDetails(id) {
            return $q(function (resolve, reject) {
                PopupService.showPatientMedicationsDetailsPopup(id).result.then(function (data) {
                    resolve();
                })
            })
        }

        function signPatientMedications(selected) {
            var ids = _.map(selected, function (item) {
                return item.id;
            });

            return $q(function (resolve, reject) {
                PopupService.showSignaturePopup().result.then(function (data) {
                    PatientMedication.signMany({
                        signature: data.employeeSignature,
                        pin: data.employeeSignaturePin,
                        ids: ids,
                        facilityId: vm.facility.id
                    }, function (result) {
                        if (result) {
                            toastr.success("The Patient Medication was signed successfully.");
                        } else {
                            toastr.error('Some patient Medications could not be signed.');
                        }

                        resolve();
                    }, function () {
                        toastr.error('Some patient Medications could not be signed.');
                        resolve();
                    });
                });
            })
        }
    }
})();
